import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import postsData from './data/posts.json';

function App() {
  // State to store blog posts from database (replacing the hardcoded array)
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Function to load blog posts from static data
  const loadBlogPosts = () => {
    try {
      setLoading(true);

      // Filter only published posts and sort by date (newest first)
      const publishedPosts = postsData.blogPosts
        .filter(post => post.published)
        .sort((a, b) => new Date(b.date) - new Date(a.date));

      setBlogPosts(publishedPosts);
    } catch (err) {
      console.error('Error loading blog posts:', err);
      setError('Failed to load blog posts. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  // Load data when component mounts
  useEffect(() => {
    loadBlogPosts();
  }, []);

  // Show loading state
  if (loading) {
    return (
      <div className="App">
        <div className="loading-container">
          <p>Loading blog posts...</p>
        </div>
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div className="App">
        <div className="error-container">
          <p>{error}</p>
          <button onClick={loadBlogPosts}>Try Again</button>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {/* Header Section with Flowers Background - EXACTLY as your original */}
      <header 
        className="main-header"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/new-flowers.png)`
        }}
      >
        <div className="header-content">
          <div className="logo-section">
            <img src="/images/dm-logo.png" alt="DM Logo" className="logo" />
            <div className="brand-text">
              <h1><span className="first-name">DARIA</span><span className="last-name">MARMER</span></h1>
              <p className="tagline">
                PRODUCT <strong>MANAGEMENT</strong> | PRODUCT <strong>STRATEGY</strong> | PRODUCT <strong>LOVE</strong>
              </p>
            </div>
          </div>
        </div>
        
        {/* Navigation Bar - EXACTLY as your original */}
        <nav className="main-nav">
          <ul>
            <li><Link to="/">HOME</Link></li>
            <li><Link to="/about">ABOUT</Link></li>
          </ul>
        </nav>
      </header>

      {/* Main Content - Blog Posts Grid - EXACTLY as your original, just with database data */}
      <main className="main-content">
        <div className="container">
          <div className="blog-grid">
            {blogPosts.map((post) => (
              <Link to={`/post/${post.slug}`} key={post.id} style={{textDecoration: 'none'}}>
                <article className="blog-card">
                  <div className="blog-image-container">
                    <img 
                      src={post.image} 
                      alt={post.title}
                      className="blog-image"
                      onError={(e) => {
                        // Fallback to placeholder if image doesn't load
                        e.target.src = '/images/pasted image 0.png';
                      }}
                    />
                  </div>
                  <div className="blog-content">
                    <h2 className="blog-title">{post.title}</h2>
                    <p className="blog-excerpt">{post.excerpt}</p>
                    <div className="blog-meta">
                      <span className="blog-date">{post.date}</span>
                      <span className="blog-read-time">{post.readTime}</span>
                    </div>
                  </div>
                </article>
              </Link>
            ))}
          </div>
        </div>
      </main>

      {/* Footer - EXACTLY as your original */}
      <footer className="main-footer">
        <div className="footer-content">
          <p>&copy; 2025 Daria Marmer. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;